var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "import") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add-Project",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-Screen",
    transform: "translate(-544.000000, -230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(528.000000, 214.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "import",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(50.000000, 23.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,1 C2.06700338,1 0.5,2.56700338 0.5,4.5 L0.5,149.5 C0.5,151.432997 2.06700338,153 4,153 L98,153 C99.9329966,153 101.5,151.432997 101.5,149.5 L101.5,42.9568542 C101.5,42.0285965 101.131251,41.1383578 100.474874,40.4819805 L62.0180195,2.02512627 C61.3616422,1.36874894 60.4714035,1 59.5431458,1 L4,1 Z",
    id: "Rectangle",
    stroke: "#757575",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,-0.5 L102,40.5 L65,40.5 C62.790861,40.5 61,38.709139 61,36.5 L61,-0.5 Z",
    id: "Rectangle",
    fill: "#757575"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.d3c209bd53b37d9917598b78948f04e9.svg";
export { ForwardRef as ReactComponent };